// extracted by mini-css-extract-plugin
export default {"wrapper":"_6b1cd226"};